import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-cloud-icon',
  templateUrl: './files-folder-cloud.component.html'
})
export class FilesFolderCloudComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
